import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import EmptyState from "../../../../../../../../util/component/EmptyState";
import { IBookingNote, ReactQueryKey, RouteParams } from "../../../../../../types";
import Note from "./Note";

const NoteList = ({
    isShowingNewNote
}: {
    isShowingNewNote: boolean
}) => {

    const { t } = useTranslation('booking');

    const { id: bookingId } = useParams<RouteParams>();

    const bookingNotesQuery = useQuery<IBookingNote[]>({
        queryKey: [ReactQueryKey.BookingNotes, bookingId],
        enabled: false
    });

    if (bookingNotesQuery.data?.length === 0 && !isShowingNewNote) {
        return (
            <EmptyState
                title={t("message.info.noNotesToShow")}
            />
        )
    }

    return (
        <>
            {
                bookingNotesQuery.data
                    ?.map((n, index) => (
                        <Note key={index} value={n} />
                    ))
                    .reverse()
            }
        </>
    );
};

export default NoteList;
